<div class="product-container" *ngIf="hasProducts" [ngSwitch]="viewType">
    <ng-container *ngSwitchCase="gridViewType">
      <app-product-tile *ngFor="let product of products"
                        [product]="product"
                        [combinedFacets]="combinedFacets"
                        [catalogItemPageSettings]="catalogItemPageSettings"
                        [cartProduct]="cartProduct(product)"
                        [isFavorite]="isFavorite(product)"
                        [quantityPicker]="quantityPicker"
                        [allowOutOfStockOrdering]="allowOutOfStockOrdering"
                        (onFavoriteToggle)="toggleFavorite($event)"
                        (onDetails)="openDetails($event)"
                        (onAddCart)="addCart($event)">
                        <!--[ngClass]="gridClasses(fullWidthView$ | async)" -->
      </app-product-tile>
    </ng-container>
    <ng-container *ngSwitchCase="listViewType">
      <app-product-list [products]="products"
                         [catalogItemPageSettings]="catalogItemPageSettings"
                         [combinedFacets]="combinedFacets"
                         [cartProducts]="cartProducts"
                         [favoritesProducts]="favoritesProducts"
                         [quantityPicker]="quantityPicker"
                         [allowOutOfStockOrdering]="allowOutOfStockOrdering"
                         (onFavoriteToggle)="toggleFavorite($event)"
                         (onDetails)="openDetails($event)"
                         (onAddCart)="addCart($event)">
      </app-product-list>
    </ng-container>
    <ng-container *ngSwitchCase="groupedProductsListType">
      <app-product-table [products]="products"
                                [catalogItemPageSettings]="catalogItemPageSettings"
                                [combinedFacets]="combinedFacets"
                                [cartProducts]="cartProducts"
                                [favoritesProducts]="favoritesProducts"
                                [quantityPicker]="quantityPicker"
                                [allowOutOfStockOrdering]="allowOutOfStockOrdering"
                                (onFavoriteToggle)="toggleFavorite($event)"
                                (onDetails)="openDetails($event)"
                                (onAddCart)="addCart($event)">
      </app-product-table>
    </ng-container>
</div>

<!-- <app-products-loader
  [loading]="loading"
  [viewType]="viewType"
  [gridClasses]="gridClasses(fullWidthView$ | async)"
  [productsCount]="loaderItemsCount(fullWidthView$ | async)">
</app-products-loader> -->

<div class="row compensate" *ngIf="!loading && !hasProducts">
  <div class="col-12">
    <p class="no-results">
      {{ 'catalog.empty' | translate }}
    </p>
  </div>
</div>
